import { h } from 'preact'; /** @jsx h */

import './TaxReduction.scss';

const TaxReduction = ({ viewTaxDeduction, setViewTaxDeduction, isReciept = false }) => {
    return (
        <div className="ws-products-tax-reduction">
            <div className={`ws-tax-reduction-content ${viewTaxDeduction && 'show-tax-reduction'}`}>
                <h4 className="ws-tax-reduction-title">Skattefradrag</h4>
                <p className="ws-tax-reduction-text">
                    Du kan få skattefradrag for gavene i din handlekurv. For å få skattefradrag må
                    du gi totalt 500 kr eller mer per år. Gavene vil bli automatisk påført din
                    skattemelding. Dersom forhåndsutfyllingen mangler kan du ta kontakt med oss, så
                    ordner vi det. Du kan få fradrag for gaver opp til 25 000kr per år.
                </p>
                <p className="ws-tax-reduction-text">
                    Produkter som ikke er fradragsberettiget vil ikke gi skattefradrag. Dette
                    skyldes produktets art eller betingelser satt av skatteetaten. De fleste
                    produktene i vår nettbutikk er fradragsberettiget.
                </p>
            </div>
            {!isReciept && (
                <div
                    className="ws-tax-reduction-dropdown"
                    onClick={() => setViewTaxDeduction(!viewTaxDeduction)}
                >
                    <span className="material-symbols-outlined icon">
                        {viewTaxDeduction ? 'arrow_upward' : 'arrow_downward'}
                    </span>
                    <span className="text">{viewTaxDeduction ? 'Vis mindre' : 'Vis mer'}</span>
                </div>
            )}
        </div>
    );
};

export default TaxReduction;
